import Vue from "vue";
import TContainer from "@/components/core/TContainer.vue";
import TSection from "@/components/core/TSection.vue";
import DisplayAdapter from "@/components/core/DisplayAdapter.vue";

Vue.component("TContainer", TContainer);
Vue.component("TSection", TSection);
Vue.component("DisplayAdapter", DisplayAdapter);
